import styled from 'styled-components'

import MarkdownText from '../../MarkdownText'
import breakpoints from '../../../theme/breakpoints'
import Link from '../../Link'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-bottom: 0.7px solid #3669ff;
  margin-bottom: 3.2rem;
  ${breakpoints.up('tablet')} {
    flex-direction: row;
  }
`

export const Column = styled.div``

export const Title = styled.h5`
  ${(props) => props.theme.textStyles.text};
  font-size: 1.4rem;
  font-weight: 700;
  color: ${(props) => props.theme.colors.pureWhite};
  margin-bottom: 1rem;
  ${breakpoints.up('tablet')} {
    font-size: 1.4rem;
  }
`

export const ContactUsCta = styled(Link)`
  color: ${(props) => props.theme.colors.pureWhite};
  ${(props) => props.theme.textStyles.textLargeStrong};
  font-weight: bold;
`

export const Markdown = styled(MarkdownText)<{ $isSmall?: boolean }>`
  ${(props) => props.theme.textStyles.text};
  font-size: ${(props) => (props.$isSmall ? '1rem' : '1.2rem')};
  margin-bottom: 3.2rem;
  color: ${(props) => props.theme.colors.pureWhite};

  & a {
    color: ${(props) => props.theme.colors.pureWhite};
    text-decoration: none;
  }

  & strong {
    font-weight: 700;
  }
`
